import {
	SET_JD_CAT_COVER_DATA,
	SHOW_HIDE_JD_CAT_COVER
} from '../actions/types'

const initialState = {
	listing: {
        existingJdId : [],
        nonExistingJdId: []
    },
    showCatCoverSlider : false
}

export default (state = initialState, action) => {
	const payload = action.payload;

	switch (action.type) {
		
		case SET_JD_CAT_COVER_DATA: {
			const newState = {
				...state
			};
            // console.log(payload.data);
            if(payload.data?.data?.existing_jdmartid.length || payload.data?.data?.nonexisting_jdmartid.length) {
                newState.showCatCoverSlider = true;
                newState.listing.existingJdId = payload.data?.data.existing_jdmartid;
                newState.listing.nonExistingJdId = payload.data?.data.nonexisting_jdmartid;
            }
			return newState;
		}
		case SHOW_HIDE_JD_CAT_COVER: {
			const newState = {
				...state
			};
			newState.showCatCoverSlider = payload.toggle;
			return newState;
		}
		default:
			return state;
	}
}